define('commons/tap-selector',['jquery', 'commons/element-selector', 'commons/message-manager', 'commons/live-search-field'], function($, ElementSelector, messages) {
    // Tap selector Jquery plugin
    var onOk = function() {
        if ($.isFunction(this.settings.onOkClick)) {
            var allSelected = this.elementSelector.model.allSelected;
            if (allSelected) {
                var question = "You have selected all the elements";
                var notSelectedArray = this.elementSelector.model.notSelected.asArray();
                if (notSelectedArray.length > 0) {
                    question += " except " + notSelectedArray.length + ". Continue? ";
                } else {
                    question += ". Continue? ";
                }
                if (confirm(question)) {
                    this.settings.onOkClick.call(this, notSelectedArray, allSelected);
                }
            } else {
                var selectedArray = this.elementSelector.model.selected.asArray();
                if (confirm("You have selected " + selectedArray.length + " elements. Continue?")) {
                    this.settings.onOkClick.call(this, selectedArray, allSelected);
                }
            }
        }
    };

    var loadData = function() {
        this.loaded = true;
        this.tapPopupContent.addClass("loading");
        $.ajax({
            type: 'GET',
            url: this.settings.listUrl,
            data : $.extend({'selector': true}, this.settings.data()),
            success: function(data) {
                if(typeof this.settings.fullRefreshUrl != "undefined") {
                    $.ajax({
                        type: 'GET',
                        url: this.settings.fullRefreshUrl,
                        dataType: "json",
                        success : function(spots) {
                            this.settings.onFullRefresh.call(this, spots.spots);
                            pageLoaded.call(this, data);
                        },
                        context : this
                    });
                } else {
                    pageLoaded.call(this, data);
                }
            },
            context : this
        });
    };

    var pageLoaded = function(data) {
        this.elementSelector.beforeDataLoaded();

        switch (this.settings.format) {
            case 'json':
                if (this.settings.onDataLoaded !== null){
                    data.headerContainer = this.settings.tapContent + " table.data thead";
                    data.bodyContainer = this.settings.tapContent + " table.data tbody";
                    this.settings.onDataLoaded(data);
                } else {
                    messages.error('An error has occurred with the popup content.');
                }
                break;
            default:
                // HTML By default
                this.tapPopupContent.html(data);
                break;
        }

        this.tapPopupContent.removeClass("loading");
        this.elementSelector.onDataLoaded.apply(this.elementSelector);
        var changePage = function(event) {
            var page = $(event.currentTarget).data('params');
            var params = page.split("=");
            $.ajax({
                type: 'GET',
                url: this.settings.listUrl,
                data: $.extend({selector: true, pg : params[1]}, this.settings.data()),
                success: pageLoaded,
                context : this
            });
            return false;
        };

        this.tapPopupContent.find("a.paginator-link-next").off('click').on('click', $.proxy(changePage, this));
        this.tapPopupContent.find("a.paginator-link-previous").off('click').on('click', $.proxy(changePage, this));
        this.tapPopupContent.find("a.sort-link").off('click').on('click', $.proxy(changePage, this));
        return false;
    };

    var methods = {
        init: function(options) {
            this.settings = {
                dialogOptions: {
                    'autoOpen': false,
                    'resizable': true,
                    'minWidth':600,
                    'width' : '70%',
                    'height' : 450,
                    'zindex': 100,
                    'draggable': true,
                    'dialogClass': 'list-selector-dialog',
                    'modal': true
                },
                format: 'html',
                onDataLoaded: null,
                tapContent: false,
                refresh: false,
                postUrl: null,
                data : function() {
                    return {};
                },
                filter : [{
                    parameter : 'id',
                    placeholder : 'base station id'
                }],
                onOkClick: null,
                suffix: false
            };
            $.extend(true, this.settings, options);
            this.loaded = false;
            this.id = this.settings.suffix ? '_' + this.settings.suffix: '';
            this.settings.tapContent = this.settings.tapContent ? this.settings.tapContent : '#tapcontent' + this.id;
            // Create toolbar
            this.tapPopup = this.first().dialog(this.settings.dialogOptions);
            this.tapPopup.dialog("option", "title", this.settings.title);
            var cont = $(this.tapPopup.dialog("widget").find(".ui-dialog-content"));

            var contString = "<div id='toolbar' class='toolbar top-fixed'>" +
            "<input type='hidden' id='allSelected" + this.id + "' value='false' />" +
            "<a href='#' class='toolbar-button' id='selectAll" + this.id + "'>All</a>" +
            "<a href='#' class='toolbar-button' id='unselectAll" + this.id + "'>None</a>";

            for (var i = 0; i < this.settings.filter.length; i++) {
                contString = contString.concat("<input type='search' incremental='incremental' placeholder='" + this.settings.filter[i].placeholder + "' id='idFilter" + i + "_" + this.id + "' />");
            }

            contString = contString.concat("<a href='#' class='toolbar-button validate' id='okButton" + this.id + "'>Ok</a></div>");
            cont.prepend(contString);
            this.elementSelector = new ElementSelector(cont, {
                suffix : this.id
            });
            cont.find("#okButton" + this.id).click($.proxy(onOk, this));
            var listUrl = this.settings.listUrl;
            for (var j = 0; j < this.settings.filter.length; j++) {
                cont.find("#idFilter" + j + "_"  + this.id).liveSearch({
                    searchUrl : listUrl,
                    valueParameter : this.settings.filter[j].parameter,
                    data : $.extend({'selector': true}, this.settings.data()),
                    successCallback : $.proxy(pageLoaded, this)
                });
            }
            cont.append('<div id="tapcontent' + this.id + '" class="tapListContent"></div>');
            // get content
            this.tapPopupContent = cont.find(this.settings.tapContent);
            return this;
        },
        open: function() {
            this.tapPopup.dialog("open");
            if(!this.loaded || this.settings.refresh) {
                loadData.apply(this);
            }
        },
        close: function() {
            this.tapPopup.dialog("close");
        }
    };

    $.fn.tapSelector = function(method) {
        // Method calling logic
        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' +  method + ' does not exist on jQuery.tooltip');
        }
        return this;
    };
});
